<template>
  <div class="page flex-col">
    <img
      class="label_1"
      referrerpolicy="no-referrer"
      :src="
        domainName == '灵智鸟'
          ? require('../../assets/teacher/login/FigmaDDSSlicePNGbd07d6976140b7b1680275dd1994e13a.png')
          : require('../../assets/teacher/login/FigmaDDSSlicePNGbd07d6976140b7b1680275dd1994e13ay.png')
      "
    />
    <span class="text_1">{{ domainName }}</span>
    <div class="box_1 flex-row justify-between">
      <img
        class="label_2"
        referrerpolicy="no-referrer"
        src="../../assets/teacher/login/FigmaDDSSlicePNG22133c75321b047b1e954223ec7ee6f3.png"
      />
      <div class="group_1 flex-col justify-end">
        <input
          class="text_2"
          type="text"
          placeholder="请输入账号"
          v-model="username"
        />
      </div>
    </div>
    <div class="box_2 flex-row justify-between">
      <img
        class="label_3"
        referrerpolicy="no-referrer"
        src="../../assets/teacher/login/FigmaDDSSlicePNG0e0714d7dd2186d883a3ecc1d8ed8405.png"
      />
      <div class="section_3 flex-col justify-end">
        <input
          class="text_3"
          type="password"
          placeholder="请输入密码"
          v-model="password"
          @keyup.enter="loginClick"
        />
      </div>
    </div>
    <div
      class="text-wrapper_1 flex-col"
      @click="loginClick"
    >
      <span class="text_4">登录</span>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue"
import { useRouter } from "vue-router"
import md5 from "js-md5"

import alovaInstance from "@/utils/alova"
import { getDomainName } from "@/utils/domainConfig"

const router = useRouter()
const username = ref("")
const password = ref("")

// 根据域名获取配置
const domainName = computed(() => getDomainName())

const loginClick = async () => {
  if (!username.value) {
    alert("请输入用户名")
    return
  }
  if (!password.value) {
    alert("请输入密码")
    return
  }
  try {
    const encryptedPassword = md5(password.value)
    let response = await alovaInstance.Post("/Teacher/Login", {
      username: username.value,
      password: encryptedPassword,
    })
    if (response.code === 1000) {
      localStorage.setItem("jwt_teacher_token", response.data.token)
      router.push({
        name: "TeacherCourses",
      })
    } else {
      // localStorage.removeItem("jwt_token")
      alert("登录失败，用户名或密码错误")
    }
  } catch (error) {
    console.error("登录失败:", error)
    alert("登录失败，请稍后重试")
  }
}
</script>

<style src="@/assets/common.css" />
<style scoped>
.page {
  background-color: rgba(55, 91, 165, 1);
  position: relative;
  width: 100%;
  height: 56.25vw;
  overflow: hidden;
}

.label_1 {
  width: 8.23vw;
  height: 6.41vw;
  margin: 9.89vw 0 0 45.98vw;
}

.text_1 {
  width: 5.63vw;
  height: 2.5vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.87vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.88vw;
  margin: 1.3vw 0 0 47.23vw;
}

.box_1 {
  width: 17.71vw;
  height: 2.09vw;
  margin: 5.98vw 0 0 40.98vw;
}

.label_2 {
  width: 2.09vw;
  height: 2.09vw;
}

.group_1 {
  background-color: rgba(245, 245, 245, 1);
  border-radius: 4px;
  width: 14.59vw;
  height: 2.29vw;
  border: 1px solid rgba(255, 255, 255, 0);
}

.text_2 {
  width: 14.59vw;
  height: 2vw;
  overflow-wrap: break-word;
  color: rgba(112, 112, 112, 1);
  font-size: 0.83vw;
  font-family: Segoe UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 2vw;
  margin: 0 0 0 0.2vw;
  background-color: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px solid transparent;
  padding-bottom: 2px;
}

.text_2:focus {
  border-image: linear-gradient(
    to right,
    transparent 35%,
    rgba(15, 84, 140, 1) 35%,
    rgba(15, 84, 140, 1) 65%,
    transparent 65%
  );
  border-image-slice: 1;
  outline: none;
}

.box_2 {
  width: 17.71vw;
  height: 2.09vw;
  margin: 1.61vw 0 0 40.98vw;
}

.label_3 {
  width: 2.09vw;
  height: 2.09vw;
}

.section_3 {
  background-color: rgba(245, 245, 245, 1);
  border-radius: 4px;
  width: 14.59vw;
  height: 2.29vw;
  border: 1px solid rgba(255, 255, 255, 0);
}

.text_3 {
  width: 14.59vw;
  height: 2vw;
  overflow-wrap: break-word;
  color: rgba(112, 112, 112, 1);
  font-size: 0.83vw;
  font-family: Segoe UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 2vw;
  margin: 0 0 0 0.2vw;
  background-color: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px solid transparent;
  padding-bottom: 2px;
}

.text_3:focus {
  border-image: linear-gradient(
    to right,
    transparent 35%,
    rgba(15, 84, 140, 1) 35%,
    rgba(15, 84, 140, 1) 65%,
    transparent 65%
  );
  border-image-slice: 1;
  outline: none;
}

.text-wrapper_1 {
  background-color: rgba(243, 171, 69, 1);
  border-radius: 4px;
  height: 2.71vw;
  width: 17.19vw;
  margin: 5.93vw 0 15.72vw 41.45vw;
  cursor: pointer;
}

.text_4 {
  width: 2.09vw;
  height: 1.05vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Segoe UI-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.78vw 0 0 7.55vw;
}
</style>
